// extracted by mini-css-extract-plugin
module.exports = {"container":"Top10Carousel_container__gYXeD","navigationContainer":"Top10Carousel_navigationContainer__ZULy_"};